// extracted by mini-css-extract-plugin
module.exports = {"banner":"Hero_banner__26sdJ","text":"Hero_text__3c7NC","image":"Hero_image__3AF0X","cta":"Hero_cta__Ckv56","downloads":"Hero_downloads__2Rgob"};